
export const ExternalBotEvent = {
  ARTICLE_PAGE_INTERACTION: 'external.sys.article_page_interaction',
  CANCEL_SUPPORT_REQUEST: 'external.sys.cancel_support_request',
} as const;

export type ExternalBotEventKind = typeof ExternalBotEvent[keyof typeof ExternalBotEvent]
